import { i18n } from "../../translate/i18n";

export const PATH_SEPARATOR = " › ";

export const formatPath = (path) => (path || []).join(PATH_SEPARATOR);

export const parsePath = (text) =>
  String(text || "")
    .split(/›|>/)
    .map((part) => part.trim())
    .filter(Boolean);

export const REVIEW_STATUSES = ["pending", "approved", "rejected"];

export const isManualDocument = (document) => String(document?.fileName || "").toLowerCase().endsWith(".txt");

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

const displayNames = () => {
  try {
    return new Intl.DisplayNames([i18n.language?.startsWith("en") ? "en" : "es"], { type: "region" });
  } catch {
    return null;
  }
};

export const countryName = (code) => {
  if (!code) return i18n.t("knowledge.noCountry");
  const names = displayNames();
  return names?.of(code) || code;
};

export const allCountries = () => {
  const names = displayNames();
  if (!names) return [];
  return LETTERS.flatMap((first) => LETTERS.map((second) => `${first}${second}`))
    .map((code) => {
      try {
        const name = names.of(code);
        return name && name !== code ? { code, name } : null;
      } catch {
        return null;
      }
    })
    .filter(Boolean)
    .sort((a, b) => a.name.localeCompare(b.name));
};

export const alertLabel = (alert) => i18n.t(`knowledge.alerts.${alert}`);

export const progressLabel = (progress) => {
  if (!progress) return "";
  return i18n.t(`knowledge.progress.${progress.step}`, { done: progress.done, total: progress.total });
};

export const STATUS_COLORS = {
  processing: "info",
  review: "warning",
  failed: "error",
  published: "success",
  pending: "default",
  approved: "success",
  rejected: "error",
};
